import { render, staticRenderFns } from "./detailperson.vue?vue&type=template&id=22c5ab6b&scoped=true"
import script from "./detailperson.vue?vue&type=script&lang=js"
export * from "./detailperson.vue?vue&type=script&lang=js"
import style0 from "./detailperson.vue?vue&type=style&index=0&id=22c5ab6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c5ab6b",
  null
  
)

export default component.exports